import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './tailwind.scss';
import { Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store, { persistor } from './redux/store';
import { PersistGate } from 'redux-persist/integration/react';
import history from './Utils/history';

const root = ReactDOM.createRoot(document.getElementById('root')!); // Create the root using createRoot
root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <Router history={history}>
        <App />
      </Router>
    </PersistGate>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// process.env.NODE_ENV === 'production' && reportWebVitals(console.log);
